import { DocumentMode } from '@helpers/document-mode';

import type { TransitionConfigMap } from '../types';

const ENDORSEMENTS_ARCHIVE_NOTICE = 'All endorsements on this contract will be archived too.';

const withEndorsementsArchiveNotice = (content: string, hasEndorsements?: boolean) =>
  hasEndorsements ? `${content}\n\n${ENDORSEMENTS_ARCHIVE_NOTICE}` : content;

export const FINAL_TRANSITIONS: TransitionConfigMap = {
  DRAFT: {
    [DocumentMode.SUBMISSIONS]: (context) => ({
      title: 'Return to Draft state?',
      content: withEndorsementsArchiveNotice(
        'Setting this contract back to Draft will make it editable again.',
        context.hasEndorsements,
      ),
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, return to Draft' },
      },
      icon: { type: 'warning' },
    }),
    [DocumentMode.ENDORSEMENTS]: () => ({
      title: 'Return to Draft state?',
      content: 'Setting this endorsement back to Draft will make it editable again.',
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, return to Draft' },
      },
      icon: { type: 'warning' },
    }),
  },
  FIRM_ORDER: {
    [DocumentMode.SUBMISSIONS]: (context) => ({
      title: 'Return to Firm Order state?',
      content: withEndorsementsArchiveNotice(
        'Setting this contract back to Firm Order will lock it from further edits and mark it as ready to be bound.',
        context.hasEndorsements,
      ),
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, return to Firm Order' },
      },
      icon: { type: 'warning' },
    }),
  },
  REVIEW: {
    [DocumentMode.SUBMISSIONS]: (context) => ({
      title: 'Return to Review state?',
      content: withEndorsementsArchiveNotice(
        'Setting this contract back to Review will make it read-only and ready for review.',
        context.hasEndorsements,
      ),
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, return to Review' },
      },
      icon: { type: 'warning' },
    }),
    [DocumentMode.ENDORSEMENTS]: () => ({
      title: 'Return to Review state?',
      content: 'Setting this endorsement back to Review will make it read-only and ready for review.',
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, return to Review' },
      },
      icon: { type: 'warning' },
    }),
  },
};
